import Color from '../Color.mjs'
import superMeta from '../_ARCH/metaArchNode.mjs'

export default {
    ...superMeta,
    themeColor: Color.GOLD,
    alias: '知识模型',
    // 总图节点别名：按项目子类型覆盖（需求模型B）
    aliasBySubType: {RMB: '业务场景'},
    archName: '知识地图',
    archUrl: '/ProjectBfMap',
    detailUrl: '/PaDetail',
    detailIdProp: 'paId',
    listUrl: '/PaList',
    mapProp: 'paMap',
    moduleType: 'PM',
    name: '知识结构',
    type: 'PA',
}
